import CustomerRefundPaymentDetailPage from 'domains/customer-refund-payment/pages/detail-page'
import CustomerRefundPaymentListPage from 'domains/customer-refund-payment/pages/list-page'


/**
 * Used by:
 *  - `<Sidebar>` to generate the NavItems
 *  - `<App>` to generate react-router a list of `<Route path={..} component={..}/>`
 *
 * Key Definitions:
 *
 * - `path`: the URL that the component will be displayed in
 * - `name`: Sidebar display
 * - `component`: Component to display
 * - `layout`: always /app
 */
const finance_team_refund_routes = [
  {
    path      : '/orders/refunds/payments',
    name      : 'Payment',
    component : CustomerRefundPaymentListPage,
    layout    : '/app'
  },
  {
    path      : '/orders/refunds/payments/:id',
    name      : 'Detail',
    component : CustomerRefundPaymentDetailPage,
    layout    : '/app',
    invisible : true
  }
]

export default finance_team_refund_routes
